import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { opportunityDetailActions } from '../../../redux/opportunity/opportunity/opportunityDetailState';
import DataTable from '../../../components/templates/dataTable/DataTable';

const DEFAULT_SEARCH_CONDITION = {
  id: '',
  order: 'asc',
  orderBy: 'display_order',
};

const headCells = [
  { id: 'planName', label: '商品名', sortId: 'plan_name' },
  {
    id: 'unitPrice', label: '税込単価', sortId: 'unit_price', numeric: true,
  },
  {
    id: 'quantity', label: '個数', sortId: 'quantity', numeric: true,
  },
  { id: 'taxRate', label: '税率', sortId: 'tax_rate' },
  {
    id: 'totalPrice', label: '合計金額', sortId: 'total_price', numeric: true,
  },
];

export default function OrderList(props) {
  const { id } = props;
  const dispatch = useDispatch();
  const [datas, setDatas] = useState([]);
  const [searchCondition, setSearchCondition] = useState(DEFAULT_SEARCH_CONDITION);
  const orderDatas = useSelector((state) => state.opportunityDetailStore.details);

  React.useEffect(() => {
    if (orderDatas) {
      setDatas(orderDatas);
    }
  }, [orderDatas]);

  const search = (tempCondition) => {
    dispatch(opportunityDetailActions.getOrderDetails(tempCondition));
  };

  React.useEffect(() => {
    if (id) {
      const tempSearchCondition = { ...DEFAULT_SEARCH_CONDITION, id };
      setSearchCondition(tempSearchCondition);
      search(tempSearchCondition);
    }
  }, [id]);

  const handleRequestSort = (_, property) => {
    const { order, orderBy } = property;
    const tempCondition = {
      ...searchCondition,
      orderBy,
      order,
    };
    setSearchCondition(tempCondition);
    search(tempCondition);
  };

  return (
    <DataTable
      rows={datas}
      isNoPagination
      headCells={headCells}
      procName="注文明細"
      handleRequestSort={handleRequestSort}
      order={searchCondition.order}
      orderBy={searchCondition.orderBy}
    />
  );
}
